const formatTableOptionTitle = (name?: string, identifier?: string): string => {
  const trimmedName = name?.trim() || '';
  const trimmedIdentifier = identifier?.trim() || '';

  if (trimmedName && trimmedIdentifier) {
    return `${trimmedName} (${trimmedIdentifier})`;
  }

  if (trimmedIdentifier) {
    return `(${trimmedIdentifier})`;
  }

  return trimmedName;
};

export default formatTableOptionTitle;
